import React, { useEffect, useState, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Paper } from "@mui/material";
import '../../css/hompage.css';
import { useNavigate } from "react-router-dom";
import { Navbar } from './Navbar'
import { Footer } from "../Footer";
import { Herosection } from "./Herosection";
import ExploreByLocalities from "./ExploreByLocalities";
import Projects from "./Projects";
import { PropertySection } from "./PropertySection";
import Popup1 from "./Popup";
import WhyChooseUs from "./WhyChooseUs";
import Testimonial from "./Testimonial ";
import Services from "./Services ";
import { Popularlocation } from "./Popularlocation";
import FAQSection from "./FAQSection";
import { Helmet } from "react-helmet-async";
import { Newlistingslanding } from "./Newlistingslanding";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ResaleProperty } from "./ResaleProperty";


const Homepage = () => {

    const [projects, setProjects] = useState([]);
    const [recommended, setRecommended] = useState([]);
    const [activeTab, setActiveTab] = useState("BUY");	
    const resaleSectionRef = useRef(null);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [propertyType, setPropertyType] = useState("");
    const [category, setCategory] = useState("");

    const handleSearch = () => {
        if (searchQuery.trim() !== "" || propertyType || category) {
            navigate(`/search?query=${searchQuery}&type=${propertyType}&category=${category}`);
        }
    };


    const handlePropertyClick = (property) => {
        navigate(`/property/${property.category}/${property.id}`);
        console.log(`${property.category}/${property.id}`)
    };

  

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
    };
    const setting = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true,
        responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
    };

    const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Show the popup after 5 seconds
    const timer = setTimeout(() => {
      setIsPopupOpen(true);
    }, 5000);

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const scrollTarget = sessionStorage.getItem("scrollToSection");

    if (scrollTarget === "premium-resale" && resaleSectionRef.current) {
      setTimeout(() => {
        resaleSectionRef.current.scrollIntoView({ behavior: "smooth" });
        sessionStorage.removeItem("scrollToSection");
      }, 500); // Adjust delay based on how fast your DOM loads
    }
  }, []);

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };


    return (
        <div className="homecon">



<Helmet>
  <title> Real Estate Agents In Chennai | Real Estate Brokers In Chennai | 24Krealtors</title>
  <meta name="description" content="Top Real Estate Agency Residential and Commercial Properties for Sale in Chennai. Get in touch with Team 24K Realtors for the best offers on Chennai Properties." />
  
  {/* ✅ Add Structured Data (Schema) */}
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "24krealtors",
      "url": "https://www.24krealtors.com",
      "logo": "https://www.24krealtors.com/Logo%20copy%20(1).png",
      "sameAs": [
        "https://www.facebook.com/24krealtors",
        "https://www.instagram.com/24krealtors",
        "https://www.linkedin.com/company/24krealtors/"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9884855955",
        "contactType": "Customer Support",
        "areaServed": "IN",
        "availableLanguage": ["English", "Tamil"]
      }
    }
    `}
  </script>
</Helmet>
              <ToastContainer position="top-right" autoClose={3000} />
              <Popup1 isOpen={isPopupOpen} onClose={handleClosePopup} />
            <Navbar />
            <Herosection />
            <PropertySection />
	    <div ref={resaleSectionRef}>
            <ResaleProperty />
            </div>
            <ExploreByLocalities />
            <Popularlocation />
            <Services />
            <ExploreByLocalities />
            <WhyChooseUs /> 
            <Testimonial />          
        </div>
    )
}

export default Homepage
